import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Input, notification, Select } from "antd";
import appActions from "../../../redux/getOrganizationAndRestaurant/actions";
import qrActions from "../../../redux/qr/actions";
import { useProjectState } from "../../../context/stateContext";
import { url } from "./QRManagementScanner";
import QRImages from "./QRImages";
import "./index.css";

const { setSelectedRestaurant } = appActions;
const { Option } = Select;
const { toggleScanModal, getTouchSaleTables, generateQRTXT } = qrActions;

const QRManagementSelect = () => {
  const [qrCodesCount, setQrCodesCount] = useState(1);
  const { selectedOrganization } = useProjectState();

  const { menuConfiguration } = useSelector(
    (state) => state.organizationsReducer
  );
  const { restaurants, selectedRestaurant, organizations } = useSelector(
    (state) => state.getOrganizationAndRestaurantReducer
  );

  const dispatch = useDispatch();

  const defaultOrganization = organizations.filter(
    (itemInArray) => itemInArray.id === selectedOrganization
  );

  const handleRestaurantChange = (restaurant) => {
    dispatch(setSelectedRestaurant(restaurant));
    window.localStorage.setItem("restaurantId", restaurant);
    dispatch(getTouchSaleTables());
  };

  const openScan = async () => {
    // dispatch(getTouchSaleTables());
    if (selectedRestaurant === undefined || selectedRestaurant === "") {
      notification.error({
        message: "Грешка",
        description: "Моля изберете ресторант.",
      });

      return;
    }

    dispatch(toggleScanModal());
  };

  return (
    <>
      {defaultOrganization[0]?.multipleRestaurants && (
        <div className="qr-management-select-restaurant-container">
          <p className="qr-management-select-restaurant-select">
            Изберете ресторант:
          </p>
          <Select
            className="qr-management-select-restaurant-select"
            showSearch
            placeholder="Изберете ресторант"
            value={selectedRestaurant}
            onChange={handleRestaurantChange}
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {restaurants?.map((restaurant) => (
              <Option
                key={restaurant.id}
                value={restaurant.id}
                className="qr-management-select-restaurant-options"
              >
                {restaurant.name}
              </Option>
            ))}
          </Select>
        </div>
      )}
      {window.innerWidth > 1220 && (
        <div className="qr-management-generate-qr-container">
          <p className="qr-management-generate-qr-title">Брой QR:</p>
          <Input
            type="number"
            className="qr-management-generate-qr "
            placeholder="Брой QR кодове"
            value={qrCodesCount}
            onChange={(e) => setQrCodesCount(parseInt(e.target.value))}
          />

          <Button onClick={() => dispatch(generateQRTXT(qrCodesCount))}>
            Генерирай QR TXT
          </Button>
          <QRImages qrCodesCount={qrCodesCount} />
        </div>
      )}

      <div className="qr-management-link-btns-container">
        <Button
          className="qr-management-link-btns"
          style={{
            display: menuConfiguration?.deliveryEnabled ? "block" : "none",
          }}
        >
          <a
            target="_blank"
            rel="noreferrer"
            href={
              url() + menuConfiguration?.organizationDisplayNameBulgarian || ""
            }
          >
            Delivery
          </a>
        </Button>
        <Button
          className="qr-management-link-btns"
          style={{
            display: "block",
          }}
        >
          <a
            target="_blank"
            rel="noreferrer"
            href={
              url() +
                "preorder/" +
                menuConfiguration?.organizationDisplayNameBulgarian || ""
            }
          >
            Preorder
          </a>
        </Button>
        <Button
          className="qr-management-link-btns"
          style={{
            display: "block",
          }}
        >
          <a
            target="_blank"
            rel="noreferrer"
            href={
              url() +
                "preview/" +
                menuConfiguration?.organizationDisplayNameBulgarian || ""
            }
          >
            Preview
          </a>
        </Button>
      </div>
      {selectedRestaurant !== undefined && (
        <div className="qr-management-attach-table-container">
          <Button
            type="primary"
            className="qr-management-scan-qr"
            onClick={openScan}
          >
            Сканирай QR
          </Button>
          <Button
            type="primary"
            className="qr-management-scan-qr qr-management-attach-table-without-scan"
            onClick={() => dispatch({ type: qrActions.OPEN_QR_MODAL })}
          >
            Закачете QR
          </Button>
        </div>
      )}
    </>
  );
};

export default QRManagementSelect;
